import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {setVerifyEmailModalOpen, useVerifyEmailModal} from 'entities/app'
import {useUser, VerifyEmail} from 'entities/user'
import {OpenMailButton} from 'features/buttons/openMailButton'
import {TimerButton} from 'features/buttons/timerButton'
import {Close} from 'shared/ui/icons'
import {AuthModal} from 'shared/ui/modals'
import sharedStyles from 'shared/ui/styles/authModals.module.scss'
import customStyles from '../signInModal/styles.module.scss'

export const VerifyEmailModal: FC = () => {
  const dispatch = useDispatch()
  const isOpen = useVerifyEmailModal()
  const {profile} = useUser()

  const onClickHandler = (timerStart: Function) => {
    timerStart()

    VerifyEmail().catch(console.error)
  }

  if (!isOpen) return <></>

  return (
    <AuthModal>
      <div className={customStyles.modal}>
        <div onClick={() => dispatch(setVerifyEmailModalOpen(false))} className={customStyles.modal__close}>
          <Close />
        </div>
        <p className={customStyles.modal__title}>Verify your email</p>
        <span className={sharedStyles.modal__title__description}>
          Find our email in your inbox at  <span className={customStyles.email}>{profile.email}</span> and press the “Confirm email” button in it.
        </span>
        <div className={customStyles.btnContainer}>
          <OpenMailButton />
          <TimerButton onClick={onClickHandler} />
        </div>
      </div>
    </AuthModal>
  )
}